import { createFeatureSelector, createSelector } from '@ngrx/store';
import { LocationsState } from '../reducers/locations.reducer';

export const selectLocationsState =
  createFeatureSelector<LocationsState>('locations');

export const selectAllLocations = createSelector(
  selectLocationsState,
  (state) => state.items
);

export const selectSelectedLocationId = createSelector(
  selectLocationsState,
  (state) => state.selectedId
);

export const selectSelectedLocation = createSelector(
  selectLocationsState,
  (state) => state.items.find(item => item.id === state.selectedId) || null
);

export const selectLocationsLoading = createSelector(
  selectLocationsState,
  (state) => state.isLoading
);

export const selectLocationsError = createSelector(
  selectLocationsState,
  (state) => state.error
);

export const selectLocationsTotal = createSelector(
  selectLocationsState,
  (state) => state.total
);
